import { render } from "./BarraLateral.vue?vue&type=template&id=f60c0f24&ts=true"
import script from "./BarraLateral.vue?vue&type=script&lang=ts"
export * from "./BarraLateral.vue?vue&type=script&lang=ts"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__